module.exports = __webpack_public_path__ + "media/assets/images/loading-spinner-8d4bc204b5001679668431342109a8b9.gif";